import { Typography, TypographyProps } from "@mui/material"
import React from "react"
import { ReactNode, useMemo } from "react"

import { theme, TI } from "../../utilities/theme"

export const DGText = ({
  tx,
  sx,
  children,
  ...rest
}: Omit<TypographyProps, "children"> & {
  tx: TI
  children?: ReactNode
}) => {
  const style = useMemo(
    () => ({ ...theme.typography[tx], ...(sx ?? {}) }),
    [tx, sx],
  )
  return (
    <Typography sx={style} {...rest}>
      {children}
    </Typography>
  )
}
